import {
  StyleSheet,
  Text,
  View,
  FlatList,
  Image,
  TouchableOpacity,
} from "react-native";
import { FontAwesome } from "@expo/vector-icons";
import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "@emotion/styled";
import {
  THEME_COLORS,
  FONT_FAMILY,
  OTHER_CONSTANTS,
  commonStyles,
  FONT_SIZE,
  images,
} from "../themes";
import ErrorMsg from "../component/ErrorMsg";
import CustomSelect from "./CustomSelect";
import TextInput from "../../common/component/CustomTextInputTwo";
import { Modal } from "../component";
import Button from "../component/CustomButtonTwo";
import { v4 as uuidv4 } from "uuid";
import {
  IS_LOOSE_ITEM_OPTIONS,
  VERIFIED_OPTIONS,
  PACKING_TYPE_OPTIONS,
  HSN_TAX_CODES,
} from "../../common/helper";
import BrandSelect from "../../screen/SparePartsScreen/component/Selects/BrandSelect";
import CategorySelect from "../../screen/SparePartsScreen/component/Selects/CategorySelect";
import UnitSelect from "../../screen/SparePartsScreen/component/Selects/UnitSelect";
import MakeModelVariantYearSelectV2 from "@screen/SparePartsScreen/component/Selects/MakeModelVariantYearSelectV2";
import { ImageAlbumButton } from "../../common/component/BeforeAfterImages";

interface IMicroJobRowProps {
  data: any;
  isRemoveButtonVisible?: boolean;
  isAddButtonVisible?: boolean;
  onRemoveButtonClick?: (obj) => void;
  onAddButtonClick?: () => void;
  updateProductJobRowData?: (object) => void;
  bgColor?: string;
  uploadFile: (obj: any, data: any) => void;
  mmvyData: any[];
  errorMessage: string;
  editing?: boolean;
  showModal?: boolean;
}

const ProductListRow = (props: IMicroJobRowProps) => {
  const {
    data,
    updateProductJobRowData,
    mmvyData,
    errorMessage,
    editing,
    showModal,
  } = props;
  const inputRef = useRef(null);
  const [showAlert, setShowAlert] = useState(null);
  let mmvyFlattenedData = [];

  useEffect(() => {
    if (!editing) {
      if (data?.isLooseItem?.value == false) {
        updateProductJobRowData({
          packingType: PACKING_TYPE_OPTIONS[0],
          size: "1",
        });
      } else {
        updateProductJobRowData({
          packingType: data?.packingType,
          size: data?.size,
        });
      }
    }
  }, [data?.isLooseItem?.value, editing]);

  const createMmvyData = (data) => {
    data.map((item) => {
      let mmvyLevel = 0;
      const obj = {
        level: mmvyLevel,
        id: item.id,
        name: item.name,
        displayName: item.display_name,
      };

      mmvyFlattenedData.push(obj);
      mmvyLevel++;
      item.models.map((model) => {
        const modelObj = {
          level: mmvyLevel,
          id: model.id,
          name: model.name,
          displayName: model.display_name,
          isLeaf: true,
        };

        mmvyFlattenedData.push(modelObj);
      });
    });
  };

  createMmvyData(mmvyData);

  const handleChange = (event) => {
    const fileArray = Array.from(event.target.files);
    addImageFiles(fileArray);
  };

  const addImageFiles = (files: any[]) => {
    if (files.length) {
      const fileSize = files[0].size;
      const fileMb = fileSize / 1024 ** 2;
      if (fileMb >= 10) {
        alert("Please select a file less than 10MB.");
        return;
      }
      updateProductJobRowData({
        image: [
          ...data.image,
          {
            file: files[0],
          },
        ],
      });
      props.uploadFile(files[0], data);
    }
  };

  const createImageUrl = (data) => {
    let imageUrl = [];
    data?.image?.forEach((i) => {
      if (i && i.file) {
        imageUrl.push(URL.createObjectURL(i.file));
      } else if (i !== "" && i) {
        imageUrl.push(i);
      }
    });
    return imageUrl;
  };

  const selectIfIsLoose = (value) => {
    if (!value.length) return;
    setShowAlert(!!value);
    updateProductJobRowData({ isLooseItem: value[0] });
  };

  const productName = data && data.productName ? data.productName : "";
  const partNumber = data && data.partNumber ? data.partNumber : "";
  const category = data && data.category ? data.category : "";
  const mrp = data && data.mrp ? data.mrp : "";
  const brand = data && data.brand ? data.brand : null;
  const description = data && data.description ? data.description : "";
  const mmvy = data && data.mmvy ? data.mmvy : null;
  const hsnData = data && data.hsn ? data.hsn : null;
  const isLooseItem = data && data.isLooseItem ? data.isLooseItem : null;
  const isVerified = data && data.isVerified ? data.isVerified : null;
  const packingType = data && data.packingType ? data.packingType : "";
  const size = data && data.size ? data.size : "";
  const measurementUnitData =
    data && data.measurementUnit ? data.measurementUnit : null;
  const showUnitSelect =
    !!editing || (!editing && !!isLooseItem && isLooseItem.value);
  const imageUrl = createImageUrl(data);
  function checkValidDecimal(value) {
    if (value != 0 && value > 0) return true;
    else return false;
  }

  return (
    <View
      style={[
        styles.card,
        props.errorMessage !== ""
          ? { backgroundColor: THEME_COLORS.lightPink }
          : null,
      ]}
    >
      <View style={{ flexDirection: "row" }}>
        <View style={styles.row}>
          <TextInput
            label={"Product Name"}
            value={productName}
            placeholder={"Product Name"}
            error={false}
            onChangeText={(text) => {
              updateProductJobRowData({ productName: text });
            }}
          />

          <TextInput
            label={"Part No"}
            value={partNumber}
            placeholder={"Part No"}
            error={false}
            onChangeText={(text) => {
              updateProductJobRowData({
                partNumber: text.toUpperCase().trim(),
              });
            }}
            // function check(val){
            //     let value = Number(val)
            //     if(value !== 0 && value >0) return Math.floor(value) !== value ? value.toFixed(2) : value
            //     else if (value < 0) console.log("value is less than zero")
            // }
          />

          {showModal && (
            <BrandSelect
              onChange={(value) => {
                updateProductJobRowData({
                  brand: value.length
                    ? {
                        id: value[0].id,
                        brandName: value[0].brandName,
                      }
                    : null,
                });
              }}
              value={brand}
            />
          )}

          {showModal && (
            <CategorySelect
              onChange={(value) => {
                updateProductJobRowData({
                  category: value.length
                    ? {
                        categoryName: value[0].categoryName,
                        categoryDisplayName: value[0].categoryDisplayName,
                      }
                    : null,
                });
              }}
              value={category}
            />
          )}

          {showModal && (
            <View style={{ marginHorizontal: 10 }}>
              <MakeModelVariantYearSelectV2
                multi={true}
                showCustomHeader={true}
                selectedMmvyIds={mmvy}
                onSelect={(value) => {
                  updateProductJobRowData({
                    mmvy: value
                      .filter((item) => item.id !== null)
                      .map((item) => ({
                        id: item.id,
                        isVerified: item?.isVerified,
                      })),
                  });
                }}
              />
            </View>
          )}

          <TextInput
            label={"MRP"}
            placeholder={"MRP"}
            value={mrp}
            error={false}
            onChangeText={(text) => {
              !isNaN(text) &&
                updateProductJobRowData({
                  mrp: parseInt(text, 10),
                });
            }}
          />

          <TextInput
            label={"Description"}
            placeholder={"Description"}
            value={description}
            error={false}
            onChangeText={(text) => {
              updateProductJobRowData({
                description: text,
              });
            }}
          />

          {!editing && (
            <CustomSelect
              label={"Is Loose"}
              isClearVisible={true}
              labelField={"label"}
              valueField={"id"}
              disabled={false}
              isLabelVisible={true}
              searchBy={"label"}
              values={!!isLooseItem ? [isLooseItem] : []}
              options={IS_LOOSE_ITEM_OPTIONS}
              isRequired={true}
              fieldName={"IsLoose"}
              onChange={(value) => selectIfIsLoose(value)}
            />
          )}

          {showModal && (
            <View style={{ marginStart: 10 }}>
              <CustomSelect
                label={"HSN"}
                isClearVisible={true}
                labelField={"code"}
                valueField={"id"}
                disabled={false}
                isLabelVisible={true}
                searchBy={"code"}
                values={!!hsnData ? [hsnData] : []}
                options={HSN_TAX_CODES}
                isRequired={true}
                fieldName={"HSN"}
                onChange={(value) => {
                  updateProductJobRowData({ hsn: value[0] });
                }}
              />
            </View>
          )}

          {showModal && (
            <CustomSelect
              label={"Is Verified"}
              isClearVisible={true}
              labelField={"label"}
              valueField={"id"}
              disabled={false}
              isLabelVisible={true}
              searchBy={"label"}
              values={!!isVerified ? [isVerified] : []}
              options={VERIFIED_OPTIONS}
              isRequired={true}
              fieldName={"IsVerified"}
              onChange={(value) => {
                updateProductJobRowData({ isVerified: value[0] });
              }}
            />
          )}

          <View style={{ marginHorizontal: 10 }}>
            <CustomSelect
              label={"Packing Type"}
              isClearVisible={true}
              labelField={"label"}
              valueField={"value"}
              disabled={isLooseItem?.value == false}
              isLabelVisible={true}
              searchBy={"label"}
              values={!!packingType ? [packingType] : []}
              options={PACKING_TYPE_OPTIONS}
              isRequired={true}
              fieldName={"packingType"}
              onChange={(value) => {
                updateProductJobRowData({ packingType: value[0] });
              }}
            />
          </View>
          <TextInput
            label={"Qty/Packing"}
            placeholder={"Qty/Packing"}
            value={size.value ? size.value : size}
            error={false}
            disabled={
              editing
                ? isLooseItem?.value == false && Number(size.value) !== 0
                : isLooseItem?.value == false
            }
            onChangeText={(text) => {
              const validated = isLooseItem?.value
                ? text.match(/^(\d*\.{0,1}\d{0,1}$)/)
                : text.match(/^\d{0,7}$/);
              if (validated) {
                updateProductJobRowData({
                  size: text,
                });
              }
            }}
          />

          <UnitSelect
            disabled={isLooseItem?.value == false}
            onChange={(value) => {
              updateProductJobRowData({ measurementUnit: value[0] });
            }}
            value={measurementUnitData}
          />
          {imageUrl.map((i, indx) => {
            return (
              <View
                style={{
                  position: "relative",
                  marginHorizontal: 16,
                  marginTop: 8,
                }}
              >
                <ImageAlbumButton
                  images={[{ url: i }]}
                  showNoCount={true}
                  height={72}
                  width={250}
                />
                <TouchableOpacity
                  style={{ position: "absolute", right: "-12px", top: "-6px" }}
                  onPress={() =>
                    updateProductJobRowData({
                      image: data.image.filter((k, ind) => indx !== ind),
                      imageSlug: data.imageSlug.filter(
                        (k, ind) => indx !== ind
                      ),
                    })
                  }
                >
                  <Image
                    source={require("../../assets/productImgDelete.svg")}
                    style={{ width: 24, height: 24 }}
                  />
                </TouchableOpacity>
              </View>
            );
          })}
          <TouchableOpacity
            style={styles.dashedBox}
            onPress={() => inputRef.current.click()}
          >
            <input
              style={{ display: "none" }}
              onChange={(e) => handleChange(e)}
              type="file"
              accept=".jpeg, .png, .svg, .jpg, .jfif"
              ref={inputRef}
            />
            <Text style={{ color: THEME_COLORS.pink }}>Add Parts Image</Text>
          </TouchableOpacity>

          {/* {props.errorMessage && <ErrorMsg errorMsg={props.errorMessage}/>} */}
        </View>

        {!editing && (
          <View
            style={{
              width: 150,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <View style={{ flexDirection: "row" }}>
              {props.isAddButtonVisible && (
                <TouchableOpacity
                  onPress={props.onAddButtonClick}
                  style={{ padding: 10 }}
                >
                  <Image source={images.addIcon} style={styles.image} />
                </TouchableOpacity>
              )}
              {props.isRemoveButtonVisible && (
                <TouchableOpacity
                  onPress={() => props.onRemoveButtonClick(data)}
                  style={{ padding: 10 }}
                >
                  <Image source={images.removeIcon} style={styles.image} />
                </TouchableOpacity>
              )}
            </View>
          </View>
        )}
      </View>
      <>
        <Modal
          isVisible={showAlert}
          onBackdropPress={() => setShowAlert(null)}
          layout={"fit-content"}
        >
          <Text>
            Please note, you won't be able to change this setting later
          </Text>
          <Button
            text={"Ok"}
            textColor={THEME_COLORS.primary}
            width={100}
            height={30}
            onPress={() => setShowAlert(null)}
            backgroundColor={THEME_COLORS.white}
            style={styles.customBtn}
          />
        </Modal>
        {errorMessage && <ErrorMsg errorMsg={errorMessage} />}
      </>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    // justifyContent: 'space-between',
    // borderBottomWidth: 1,
    // borderBottomColor: THEME_COLORS.border2,
    zIndex: "auto",
    marginVertical: 10,
  },
  row: {
    flex: 1,
    flexDirection: "row",
    flexWrap: "wrap",
    padding: 20,
  },
  labelText: {
    color: "#200E36",
    fontWeight: "bold",
    fontFamily: "Roboto",
    height: OTHER_CONSTANTS.inputHeight,
  },
  justifyContentCenter: {
    justifyContent: "center",
  },
  columnPadding: {
    padding: 5,
    flex: 1,
  },
  inputMargins: {
    marginTop: 5,
    marginBottom: 5,
  },
  addRemoveColumn: {
    alignItems: "center",
    justifyContent: "space-around",
  },
  cursorPointer: {
    cursor: "pointer",
  },
  selectField: {
    zIndex: "auto",
  },
  image: {
    width: 25,
    height: 25,
  },
  dashedBox: {
    height: 72,
    width: 240,
    borderWidth: 2,
    justifyContent: "center",
    alignItems: "center",
    borderColor: THEME_COLORS.pink,
    borderRadius: 8,
    borderStyle: "dashed",
    margin: 10,
    marginStart: 20,
  },
  customBtn: {
    // height: 40,
    // width: 100,
    // backgroundColor:THEME_COLORS.pink,
    borderRadius: 6,
    justifyContent: "center",
    alignItems: "center",
    marginHorizontal: 10,
  },
});

const ImageInput = styled.input`
  width: 250px;
  height: 80px;
  border: 1px dashed pink;
  border-radius: 8px;
`;

export default ProductListRow;
// const getCompareObject = (props: IMicroJobRowProps) => {
//     return {
//         isAddButtonVisible: props.isAddButtonVisible,
//         isRemoveButtonVisible: props.isRemoveButtonVisible,
//         isAddRemoveButtonViewVisible: props.isAddRemoveButtonViewVisible,
//         isMicroJobRowEditable: props.isMicroJobRowEditable,
//         ...props.mjrData
//     }
// };
// const areEqual = (nextProps: IMicroJobRowProps, prevProps: IMicroJobRowProps) => {
//     return shallowEqual(getCompareObject(nextProps), getCompareObject(prevProps));
// };
// export default React.memo(ProductListRow, areEqual);
